module.exports = __webpack_public_path__ + "static/inondation-6b90346d9fb54f6738f38c154981270c.jpg";